export function replaceS3WithCF(url) {
  return url
    .replace('regna-static-media-cf.dev.regna.ai', 'd140o3th0axpm.cloudfront.net')
    .replace('regna-static-media-cf.regna.ai', 'd1yaehd0wcvc0v.cloudfront.net');
}
